import { cn } from '@quoter/web-core'
import type { Level } from '@/lib/foods'
import { useI18n } from '@/hooks/useI18n'

// Traffic-light colours are the one place LowFodmaps leaves the theme ramps: green,
// amber and red carry the meaning by themselves, so they are fixed, and each
// pill also says the word for anyone who cannot tell them apart.
const STYLE: Record<Level, string> = {
  low: 'bg-[#dcefd9] text-[#1f5a2a]',
  moderate: 'bg-[#fbe7b8] text-[#7a4d00]',
  high: 'bg-[#f8d3cb] text-[#8c2415]',
}
const DOT: Record<Level, string> = {
  low: 'bg-[#3d9950]',
  moderate: 'bg-[#d99a14]',
  high: 'bg-[#d0492f]',
}

export function LevelPill({ level, className }: { level: Level; className?: string }) {
  const { t } = useI18n()
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-[12px] font-bold',
        STYLE[level],
        className,
      )}
    >
      <span className={cn('h-2 w-2 rounded-full', DOT[level])} aria-hidden />
      {t.levels[level]}
    </span>
  )
}

export function LevelDot({ level }: { level: Level }) {
  return <span className={cn('inline-block h-2.5 w-2.5 shrink-0 rounded-full', DOT[level])} aria-hidden />
}
